var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecording(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "recorded_session_greyed_out",
    "data-name": "recorded session greyed out",
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 92.768,
    viewBox: "0 0 134 92.768",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video",
    d: "M18.9,92.768A18.916,18.916,0,0,1,0,73.874V18.9A18.918,18.918,0,0,1,18.9,0H80.742A18.924,18.924,0,0,1,99.628,18.162L117.5,11.008a12.033,12.033,0,0,1,15.631,6.7A11.91,11.91,0,0,1,134,22.17V70.591a12.02,12.02,0,0,1-16.5,11.162L99.628,74.6A18.923,18.923,0,0,1,80.742,92.768ZM10.3,18.9V73.874a8.6,8.6,0,0,0,8.6,8.589H80.742a8.6,8.6,0,0,0,8.589-8.589V18.9a8.6,8.6,0,0,0-8.589-8.6H18.9A8.61,8.61,0,0,0,10.3,18.9ZM121.337,72.186a1.719,1.719,0,0,0,2.352-1.595V22.17a1.719,1.719,0,0,0-2.352-1.595L99.642,29.256V63.512Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording);
export default __webpack_public_path__ + "static/media/recording.9af3a2e663be865104deaa23110c8f16.svg";
export { ForwardRef as ReactComponent };